// extracted by mini-css-extract-plugin
module.exports = {"simulateAccordion":"styles_simulateAccordion__kG5gW","loadingText":"styles_loadingText__5TUDj","result":"styles_result__v3TOL","skeletonWrapper":"styles_skeletonWrapper__YO0DW"};